import { notifications } from "@mantine/notifications"
import { useMutation } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useDeleteOpChainMutation = () =>
  useMutation({
    mutationFn: async (id: string) => {
      const res = await httpClient.delete(`/admin/op-chain/${id}`)
      return res.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(["findAllOpChain"])
      notifications.show({
        title: "Success",
        message: "Operation chain deleted",
        color: "teal",
      })
    },
    onError: () => {
      notifications.show({
        title: "Error",
        message: "Failed to delete operation chain",
        color: "red",
      })
    },
  })
